import { useState } from 'react';
import { ChevronDown, ChevronUp, Info } from 'lucide-react';
export default function DescriptionCard({ title = 'How to use', children, defaultOpen = true, dataTestid = 'description-card' }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div data-testid={dataTestid} className="flex items-start gap-3 p-4 bg-bg-paper border-l-4 border-electric-blue rounded-none">
      <Info size={20} className="text-electric-blue flex-shrink-0 mt-0.5" aria-hidden="true" />
      <div className="flex-1">
        <button type="button" onClick={() => setIsOpen((v) => !v)} aria-expanded={isOpen} data-testid="description-card-toggle" className="w-full flex items-center justify-between gap-2 text-left focus:outline-none focus:ring-2 focus:ring-electric-blue">
          <span className="font-sandvik-headline font-normal text-base text-carbon-black">{title}</span>
          <span className="md:hidden text-n5">{isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}</span>
        </button>
        <div className={`mt-2 text-sm font-sandvik-text text-n7 leading-relaxed ${isOpen ? 'block' : 'hidden md:block'}`}>{children}</div>
      </div>
    </div>
  );
}
